import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *资料列表
 * @param params
 * 
*/

export const annexList = params => Http.get(`${baseUrl}/course/annex`, { params })

/**
 *新增资料
 * 
*/

export const addAnnex = params => Http.post(`${baseUrl}/course/annex`, params )

/**
 *修改资料状态
 * 
*/

export const editAnnex = params => Http.put(`${baseUrl}/course/annex`, params )

/**
 *删除资料
 * 
*/

export const delAnnex = id => Http.delete(`${baseUrl}/course/annex/${id}` )
